// extracted by mini-css-extract-plugin
module.exports = {"container":"sorting_container__1zjEQ","select":"sorting_select__iYUt1"};